import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  return (
    <section className="py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              精选文章
            </h2>
            <p className="text-foreground-600">
              编辑精选的深度好文，助您在成长路上走得更远。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredArticles.slice(0, 4).map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/career-development"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-background-300 text-foreground-700 font-medium text-sm hover:bg-background-50 hover:border-primary-300 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            浏览全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}